export default {
  "APP_COMMERCE_VIEW": "COMMERCEUSER_VIEW",
  "APP_PRODUCT_IDENTIFIER_UPDATE":"COMMON_ADMIN",
  "PICKING_APP_VIEW": "PICKING_APP_VIEW"
} as any